import moment from "moment";
import i18n from "@/lang/i18n";
import { store } from "@/store";
import KeycloakLib from "@/libs/Keycloak";
import jwt_decode from "jwt-decode";

const clientLocale = localStorage.getItem("language");
const formatDateClient =
  clientLocale === "en" ? "MM-DD-YYYY HH:mm" : "DD-MM-YYYY HH:mm";

export const setTimezone = (time, isLocalDate) => {
  let date = isLocalDate ? time : new Date(time + " UTC");
  let today = new Date();
  if (today.toLocaleDateString() === date.toLocaleDateString()) {
    return i18n.t("chat_room.today") + moment(date).format("HH:mm");
  }
  let yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  if (yesterday.toLocaleDateString() === date.toLocaleDateString()) {
    return i18n.t("chat_room.yesterday") + moment(date).format("HH:mm");
  }
  return moment(date.toLocaleString()).format(formatDateClient);
};
export const checkLoginExpired = () => {
  const token = KeycloakLib.getToken();
  let timeExpiredLocal = store.getters["chat/getTimeExpired"];
  let timeExpiredKeyCloak = jwt_decode(token).exp + "000";
  if (+timeExpiredLocal === +timeExpiredKeyCloak) return;
  store.dispatch("chat/clearInfoChat");
  store.commit("chat/setTimeExpired", timeExpiredKeyCloak);
};
